import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import NavbarThree from "../components/NavbarThree";
import ServiceAreaGroup from "../components/ServiceAreaGroup";

const Service = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* Navigation Bar */}
      <NavbarThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"Products"} />

      {/* Service Area One */}
      <ServiceAreaGroup />

      {/* Footer One */}
      <FooterThree />
    </>
  );
};

export default Service;
